import { Grid, Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { I18nNamespace } from '~/common/types';
import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';

export type LabelCellValue = Union.Nullable<string>;

export interface LabelCellProps<R extends GridValidRowModel = any> {
  value: LabelCellValue;
  additionalInfo?: React.ReactNode;
  row?: R;
  sectionHeader?: boolean;
}

export const LabelCell = <R extends GridValidRowModel = any>({
  value,
  sectionHeader,
  additionalInfo,
}: LabelCellProps<R>) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'ContractDemandAwardingWidget' });
  const renderedValue = value ? t(`label.${value}`) : NULLISH_CELL_VALUE;

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={8} pt={sectionHeader ? 6 : 0}>
        {sectionHeader ? (
          <Typography variant="body2" fontWeight="bold">
            {renderedValue}
          </Typography>
        ) : (
          renderedValue
        )}
      </Grid>
      {additionalInfo && (
        <Grid size={4}>
          <Typography variant="body2" color="textSecondary">
            {additionalInfo}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
